import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsUpFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.0124 1.00008C11.6294 0.995334 11.2773 1.20978 11.1058 1.55227L7.65583 8.44227L7.65447 8.445C7.5887 8.57735 7.49464 8.69305 7.37947 8.78418C7.13978 8.97385 7 9.26272 7 9.56837V22C7 22.5523 7.44772 23 8 23H17.5C18.1491 23 18.7807 22.7895 19.3 22.4C19.8193 22.0105 20.1984 21.4628 20.3801 20.8396L22.71 12.84C22.8404 12.3929 22.8649 11.9216 22.7816 11.4633C22.6983 11.0051 22.5094 10.5726 22.23 10.2C21.9506 9.82741 21.5882 9.525 21.1716 9.31672C20.7551 9.10844 20.2957 9 19.83 9H15.2718L15.9708 6.11969L15.9714 6.11753C16.12 5.51404 16.1306 4.88478 16.0022 4.27663C15.8736 3.66777 15.6092 3.09582 15.2285 2.60352C14.8479 2.11123 14.3609 1.71131 13.804 1.43366C13.2471 1.156 12.6346 1.00778 12.0124 1.00008ZM4 9C3.20435 9 2.44129 9.31607 1.87868 9.87868C1.31607 10.4413 1 11.2044 1 12V20C1 20.7957 1.31607 21.5587 1.87868 22.1213C2.44129 22.6839 3.20435 23 4 23C4.55228 23 5 22.5523 5 22V10C5 9.44771 4.55228 9 4 9Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgThumbsUpFill);
export { ForwardRef as ReactComponent };
